<template>
	<Badge
		v-if="labelKey"
		color="subtle"
		variant="statusTag"
		class="whitespace-nowrap"
	>
		<component
			:is="iconComponent"
			v-if="iconComponent"
			:size="14"
			class="flex-shrink-0"
		/>
		<span>{{ $t(labelKey) }}</span>
	</Badge>
</template>

<script>
import Badge from '~/components/ui/common/Badge'
import { IconFileTimes, IconTimesCircle } from '~/components/Icons'
import { getDeclineSourceLabelKey } from '~/utils/applicationDeclineSource'

const DECLINE_SOURCE_ICONS = Object.freeze({
	invitation_declined: IconTimesCircle,
	withdrawn: IconFileTimes
})

export default {
	name: 'ApplicationDeclineSourceBadge',
	components: {
		Badge
	},
	props: {
		source: {
			type: String,
			default: null
		}
	},
	computed: {
		labelKey() {
			return getDeclineSourceLabelKey(this.source)
		},
		iconComponent() {
			return DECLINE_SOURCE_ICONS[this.source] || null
		}
	}
}
</script>
